import React, { useRef, useEffect } from "react";
import "./amenitiesList.css";

const AmenitiesList = ({ propertyData, onClose }) => {
  const overlayRef = useRef(null);

  // Close if clicked on overlay (not inside modal)
  const handleClickOutside = (e) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden"; // Prevent background scroll
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      className="popup-overlay"
      ref={overlayRef}
      onClick={handleClickOutside}
    >
      <div className="popup-content">
        <div>
          <h1>
            Furnished Amenities (
            {propertyData?.furnished_amenities?.length || 0})
          </h1>
          {Array.isArray(propertyData?.furnished_amenities) &&
          propertyData.furnished_amenities.length > 0 ? (
            propertyData.furnished_amenities.map((amenity, idx) => (
              <div key={idx} style={{ display: "flex", gap: "10px" }}>
                <img src={amenity.image} alt={amenity.name} />
                <h4>{amenity.name}</h4>
              </div>
            ))
          ) : (
            <p>No Amenities</p>
          )}
        </div>

        <div>
          <h1>
            Semi-Furnished Amenities (
            {propertyData?.semifurnished_amenities?.length || 0})
          </h1>
          {Array.isArray(propertyData?.semifurnished_amenities) &&
          propertyData.semifurnished_amenities.length > 0 ? (
            propertyData.semifurnished_amenities.map((amenity, idx) => (
              <div key={idx} style={{ display: "flex", gap: "10px" }}>
                <img src={amenity.image} alt={amenity.name} />
                <h4>{amenity.name}</h4>
              </div>
            ))
          ) : (
            <p>No Amenities</p>
          )}
        </div>

        <div>
          <h1>
            Un-Furnished Amenities (
            {propertyData?.unfurnished_amenities?.length || 0})
          </h1>
          {Array.isArray(propertyData?.unfurnished_amenities) &&
          propertyData.unfurnished_amenities.length > 0 ? (
            propertyData.unfurnished_amenities.map((amenity, idx) => (
              <div key={idx} style={{ display: "flex", gap: "10px" }}>
                <img src={amenity.image} alt={amenity.name} />
                <h4>{amenity.name}</h4>
              </div>
            ))
          ) : (
            <p>No Amenities</p>
          )}
        </div>

        <button className="close-button" onClick={onClose}>
          <p style={{
            marginTop: "-7px"
          }}>x</p>
        </button>
      </div>
    </div>
  );
};

export default AmenitiesList;
